import React from "react";
import { Mic, Radio, Users, Cpu } from "lucide-react";
import AdvancedTranscriptionTesting from "../components/AdvancedTranscriptionTesting";
import MedDictateBenchmark from "../components/MedDictateBenchmark";

const capabilityCards = [
  {
    label: "Whisper live",
    value: "WebSocket",
    description:
      "Optimisez les sessions micro a faible latence pour Whisper turbo.",
    icon: Radio,
  },
  {
    label: "Imports batch",
    value: "Lab fichiers",
    description:
      "Validez la diarisation, l'identification des speakers et la precision par langue.",
    icon: Mic,
  },
  {
    label: "Empreintes vocales",
    value: "Signatures",
    description:
      "Ajoutez des signatures vocales pour ameliorer le clustering et le matching.",
    icon: Users,
  },
  {
    label: "Benchmarks",
    value: "Diff modeles",
    description:
      "Comparez les exports CT2 et les deploiements faster-whisper directement.",
    icon: Cpu,
  },
];

const TranscriptionTestingPage = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#030816] text-white">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950" />
        <div className="absolute -top-20 left-1/3 h-96 w-96 rounded-full bg-cyan-500/20 blur-[140px]" />
        <div className="absolute bottom-0 right-0 h-[28rem] w-[28rem] rounded-full bg-indigo-500/20 blur-[140px]" />
        <div className="absolute inset-0 opacity-20">
          <div className="h-full w-full [background:radial-gradient(circle_at_1px,_rgba(255,255,255,0.12)_1px,_transparent_0)] [background-size:34px_34px]" />
        </div>
      </div>

      <div className="relative z-10 px-4 pt-6 pb-12 sm:px-8 lg:px-12 space-y-8">
        <div className="rounded-3xl border border-white/10 bg-white/5 p-6 backdrop-blur-xl shadow-2xl shadow-cyan-500/10">
          <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <h1 className="text-3xl font-semibold text-white">
                Suite de validation de transcription
              </h1>
              <p className="mt-2 text-sm text-slate-300 max-w-3xl">
                Eprouvez le streaming live, les imports diarises et les flux de
                signatures speaker sur toutes les variantes de modeles de la
                stack ePV.
              </p>
            </div>
            <div className="rounded-3xl border border-white/10 bg-slate-950/40 px-6 py-4 text-right">
              <p className="text-xs uppercase tracking-[0.4em] text-cyan-200/70">
                Portee du module
              </p>
              <p className="mt-3 text-3xl font-semibold text-white">3 Suites</p>
              <p className="text-xs text-slate-400">
                live · batch · signatures
              </p>
            </div>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
            {capabilityCards.map((card) => {
              const Icon = card.icon;
              return (
                <div
                  key={card.label}
                  className="rounded-2xl border border-white/10 bg-slate-900/70 p-4"
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-xs uppercase tracking-[0.4em] text-slate-400">
                        {card.label}
                      </p>
                      <p className="mt-2 text-xl font-semibold text-white">
                        {card.value}
                      </p>
                    </div>
                    <div className="rounded-2xl border border-white/10 bg-white/5 p-2">
                      <Icon className="h-5 w-5 text-cyan-200" />
                    </div>
                  </div>
                  <p className="mt-3 text-xs text-slate-400">
                    {card.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="rounded-3xl border border-white/10 bg-slate-900/70 p-6 shadow-xl shadow-black/30">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-xs uppercase tracking-[0.4em] text-cyan-200/70">
                Atelier
              </p>
              <h2 className="mt-2 text-2xl font-semibold text-white">
                Console avancee de transcription
              </h2>
              <p className="text-sm text-slate-300">
                Utilisez votre token API, alternez entre flux temps reel et
                batch, puis exportez les diagnostics pour la QA.
              </p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-slate-200">
              Supporte Whisper large-v3, builds CT2 francaises et faster-whisper
              turbo.
            </div>
          </div>
          <div className="mt-6 rounded-2xl border border-white/5 bg-slate-950/40 p-4">
            <AdvancedTranscriptionTesting />
          </div>
        </div>

        <div className="rounded-3xl border border-white/10 bg-slate-900/70 p-6 shadow-xl shadow-black/30">
          <MedDictateBenchmark />
        </div>
      </div>
    </div>
  );
};

export default TranscriptionTestingPage;
